module.exports = __webpack_public_path__ + "public/img/brightness-on.04a9cf2f.svg";